import { createSlice } from '@reduxjs/toolkit';

export interface Dto {
    id: number;
    name: string;
}
export interface SnackbarNotificationState {
    message: string;
    type: 'default' | 'error' | 'success' | 'warning' | 'info';
    autoHideDuration?: number;
}

const initialState: SnackbarNotificationState = {
    message: '',
    type: 'info',
};

export const snackbarNotificationSlice = createSlice({
    name: 'snackbarNotifications',
    initialState,
    reducers: {
        resetMessageStore: (state) => {
            return { ...initialState };
        },
        showMessage: (state, action) => {
            state.message = action.payload.message;
            state.type = action.payload.type;
        },
    },
});

export const { resetMessageStore, showMessage } = snackbarNotificationSlice.actions;
